import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=743201f8&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=743201f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743201f8",
  null
  
)

export default component.exports